import React, { useEffect, useMemo, useState } from "react";
import { colors, fonts } from "../../Styles";
import { useTranslation } from "react-i18next";
import { Button, PrimaryPopover, SkipFeedModal } from "..";
import { ButtonTypes } from "../../Definitions";
// import { TestData as PenData} from '../../Assets/TestData/lf_Data';
import { LfLocation } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";
import { useAppSelector } from "../../Store";
import { Graph_QL } from "../../Services";
import { useSection } from "../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/useSections";

interface feedSkipPopoverProps {
  pen?: LfLocation; 
  header?: string
  fieldOverrides?: {
    fieldHeight?: string
  }
  operationView?: boolean
}

export default function FeedSkipPopover({ pen, header, fieldOverrides, operationView }:feedSkipPopoverProps) {
  const {t} = useTranslation()
  const [showSkipFeedModal, setShowSkipFeedModal] = useState(false);
  const [skipFeed, setSkipFeed] = useState<LfLocation|undefined>()

  const farm = useAppSelector(({ activeData }) => activeData.farm) ?? "";
  const domain = useMemo(()=> (Graph_QL.ObjToString({domain: farm ?? ""})),[farm]);
  const connection = useMemo(() => Graph_QL.create({ domain: farm }), [farm]);

  const { call: getLfSectionInfo, data: sectionState } = useSection(connection);

  useEffect(() => {
    getLfSectionInfo({fetchAmount: 50})
  // eslint-disable-next-line
  }, [])

  const activePen = useMemo(() => {
    if (sectionState && sectionState[domain])
    return sectionState[domain].data.flatMap((section => section.section_locations)).find(location_id => location_id.location_id === pen?.location_id)
    
  }, [domain, pen?.location_id, sectionState])

  useEffect(() => {
    setSkipFeed(activePen)
  },[activePen])
  
  const plan = () => {
    setShowSkipFeedModal(true); // Show the modal when "plan" is clicked
  };

  const forNow = () => {
    if (skipFeed) {
      // setSkipFeed({...skipFeed, feeding: !skipFeed.feeding})
    }
  };

  const standard = () => {
    console.log("standard");
  };

  // const feeding = skipFeed?.feeding ? t("on", {defaultValue:"on"}) : t("off",{defaultValue:"off"});
  // const feedingBtn = skipFeed?.feeding ? t("feed.skipForNow", {defaultValue:"For Now"}) : t("feed.startFeeding", {defaultValue: "Start Feeding"});
  
  const seperator = (
    <div style={{width: "100%", height: "2px", backgroundColor: colors.greyDarkSecondary}}/>
  )

  const _height = fieldOverrides&&fieldOverrides.fieldHeight ? fieldOverrides.fieldHeight : "25px"

  return ( 
    <div style={{width: "100%", maxWidth: "280px"}}>
      {header && <p style={{ ...fonts.header, ...fonts.fontSize4, color: colors.greyPrimary, padding: "0px 0px 2px 10px"}}>{header}</p>}
      <PrimaryPopover 
        content={<span style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
          {/* {feeding} */}
        </span>} 
        createPopoverPortal={operationView ? true : false}
        overrides={{
          contentContainer: {
            ...fonts.paragraph,
            ...fonts.fontSize4,
            // color: skipFeed?.feeding ? colors.systemGreen : colors.systemRed,
            height: _height,
            backgroundColor: colors.greyTertiary,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            padding: "0px 8px",
            overflow: "hidden",
            cursor: "pointer",
            width: "100%",
            maxWidth: "280px",
          }
        }}
        popoverHeader={t("feed.skipFeeding", {defaultValue:"Skip Feeding"})} 
        popoverContent={
          <div style={{display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "10px", width: operationView ? "100%" : "130px", height: "80px"}}>
            {/* <Button content={t("feed.planSkip", {defaultValue:"Plan"})} buttonType={ButtonTypes.textButton} onClick={plan} overrides={{baseButton: {width: "100%"}}}/> */}
            {/* {seperator} */}
            <Button
              content="lorum ipsum"
              // content={feedingBtn}
              buttonType={ButtonTypes.textButton}
              onClick={forNow}
              overrides={{ baseButton: { width: "100%" } }}
            />
            {seperator}
            <Button content={t("feed.standardSkip", {defaultValue:"Standard"})} buttonType={ButtonTypes.textButton} onClick={standard} overrides={{baseButton: {width: "100%"}}}/>
          </div>
        }
      /> 
      {/* Render SkipFeeding modal when showSkipFeedModal is true */}
      {showSkipFeedModal && <SkipFeedModal isModalOpen={showSkipFeedModal} goBack={() => setShowSkipFeedModal(false)} pen={pen}/>}
    </div> 
  )
}